/**
 * Created by PetitKero on 30/9/2016.
 */
/*eslint-disable*/

import store from '@/store/index'
import state from '@/store/state'
const mutations = {
    add:()=>{
        console.log( state.num++)
    },
    eventHandler:(state,data)=>{
        let item ={
            uuid:data.id,
            code:data.code,
            createTime:data.content.createTimeStr,
            level:data.content.level,
            content:JSON.stringify(data.content),
            extra:JSON.stringify(data.extra),
            status:data.status
        }
        state.eventData.unshift(item);  
    },
    refreshEventData:(state,data)=>{
        state.eventData = data;  
    },
}
export default mutations
